// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606191403/js/" + chunkId + "." + {"44":"6399de89","225":"9854ae88","481":"fca542c2","486":"fb7983b7","770":"6a749d8c"}[chunkId] + ".0.9118188649400206.chunk.js";
};